var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.14 22.32L44.78 54.32C44.696 54.7791 44.4541 55.1944 44.0961 55.4939C43.7382 55.7934 43.2867 55.9583 42.82 55.96H18.18C17.7133 55.9583 17.2618 55.7934 16.9039 55.4939C16.5459 55.1944 16.304 54.7791 16.22 54.32L10.86 22.32C10.8138 22.0352 10.8298 21.7438 10.9069 21.4657C10.984 21.1877 11.1203 20.9296 11.3065 20.7092C11.4927 20.4889 11.7243 20.3114 11.9856 20.1889C12.2468 20.0665 12.5315 20.0021 12.82 20H48.14C48.4319 19.9962 48.721 20.0564 48.9872 20.1763C49.2533 20.2962 49.49 20.4729 49.6806 20.694C49.8712 20.915 50.0111 21.1752 50.0905 21.4561C50.1698 21.737 50.1867 22.0319 50.14 22.32ZM52.5 14C52.5 14.5304 52.2893 15.0391 51.9142 15.4142C51.5391 15.7893 51.0304 16 50.5 16H10.5C9.96957 16 9.46086 15.7893 9.08579 15.4142C8.71071 15.0391 8.5 14.5304 8.5 14C8.5 13.4696 8.71071 12.9609 9.08579 12.5858C9.46086 12.2107 9.96957 12 10.5 12H20.5V6C20.5 5.46957 20.7107 4.96086 21.0858 4.58579C21.4609 4.21071 21.9696 4 22.5 4H38.5C39.0304 4 39.5391 4.21071 39.9142 4.58579C40.2893 4.96086 40.5 5.46957 40.5 6V12H50.5C51.0304 12 51.5391 12.2107 51.9142 12.5858C52.2893 12.9609 52.5 13.4696 52.5 14ZM36.5 12V8H24.5V12H36.5Z",
    fill: "#0098FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.61b96460b5f9c17588efd288cc285831.svg";
export { ForwardRef as ReactComponent };